const SectionBlock = (props) => {
  return (
    <div className="container max-w-6xl mx-auto bg-white shadow-sm overflow-hidden border border-solid border-primary-100 ">
      {props.children}
    </div>
  );
};

export default SectionBlock;
